module.exports = __webpack_public_path__ + "static/apple-icon-144x144-703834fa865984f24253de678504b4f9.png";